import { CUSTOM_ELEMENTS_SCHEMA, Component, inject } from '@angular/core';

import { defineCustomElement as defineFallbackHeader } from '@now/dpl-webcomponents/dist/components/now-fallback-header';
import { LIB_CONFIG } from '../../../lib.config';

defineFallbackHeader();

@Component({
  selector: 'now-wbsuche-lib-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class HeaderComponent {
  public nowPortalBasePath = inject(LIB_CONFIG).nowPortalBasePath;
}
